import {emotionStyled} from '@packages/utilities/styled';
import {TextInput} from '@packages/systems/spring';

export const BrandedTextInput = emotionStyled(TextInput)({
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: '$brandedBody',
  fontWeight: 400,
  height: '48px',
  padding: '$3 $2',
  '& input': {
    fontSize: '$brandedBody',
    fontFamily: '$brandedBody',
  },
});

export default BrandedTextInput;
